import { useAppSelector } from '@/hooks/useRedux'
import { isEmpty } from 'lodash'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { eventSelector } from '../selectors'

type Props = {
  currentPlayer: string
}

export const Step3 = ({ currentPlayer }: Props) => {
  const { t } = useTranslation()

  const { event } = useAppSelector(eventSelector)

  const { getValues } = useFormContext()
  const registrationDetails = getValues('brackets[0].registrationDetails')

  const isClubMember = () => {
    if (registrationDetails?.isParticipant1) {
      return registrationDetails?.player1?.clubMember
    }
    return registrationDetails?.player2?.clubMember
  }

  const getOption = getValues('options')
  const memberRefundAmount =
    getValues('brackets[0].memberFee') - getValues('brackets[0].registrationDetails.eventRefundedAmount')
  const nonMemberRefundFee =
    getValues('brackets[0].nonMemberFee') - getValues('brackets[0].registrationDetails.eventRefundedAmount')
  const unselectedBracketList = getValues('brackets').filter((item: any) => item.type === 'bracket' && !item.checked)
  const includeEventFee = isEmpty(unselectedBracketList)
    ? `(including the event fee of ${event?.currencyDetails?.currencySymbol}${
        isClubMember() ? memberRefundAmount : nonMemberRefundFee
      })`
    : ''

  return (
    <p className="text-sm text-navy-900 text-opacity-70">
      {getOption === 'Withdraw'
        ? `${t('event.sureRemove')} ${currentPlayer} ${t('event.fromSelectedBrackets')}`
        : getOption === 'Withdraw and Refund'
          ? `${t('event.sureRefundATotalAmount')} ${event?.currencyDetails?.currencySymbol}${getValues(
              'total'
            )} ${includeEventFee} and remove ${currentPlayer} ${t('event.fromSelectedBrackets')}`
          : getOption === 'Refund Only'
            ? `${t('event.sureRefundATotalAmount')} ${event?.currencyDetails?.currencySymbol}${getValues(
                'total'
              )} to ${currentPlayer}?`
            : ''}
    </p>
  )
}
